import { render } from "./unit.vue?vue&type=template&id=43730a72&scoped=true"
import script from "./unit.vue?vue&type=script&lang=js"
export * from "./unit.vue?vue&type=script&lang=js"

import "./unit.vue?vue&type=style&index=0&id=43730a72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43730a72"]])

export default __exports__